import { toReadableTimestamp } from '../../utils/orderUtils';

export default function OrderSummary({ order, testMode }) {
    if (!order) return null;

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Order ID:
                        </td>
                        <td style={{ 
                            fontFamily: 'var(--font-family-mono)', 
                            fontWeight: 'var(--font-weight-medium)',
                            color: 'var(--text-secondary)'
                        }}>
                            {order.id}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Order Status:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.status}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Number of Items:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)'
                        }}>
                            {order.items.reduce((acc, item) => {
                                return acc + item.quantity;
                            }, 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Time Ordered:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {toReadableTimestamp(order.timestamp)}
                        </td>
                    </tr>
                    {order.redeemed_in_order && (
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Redeemed In Order:
                            </td>
                            <td style={{ 
                                fontFamily: 'var(--font-family-mono)', 
                                fontWeight: 'var(--font-weight-medium)',
                                color: 'var(--text-secondary)'
                            }}>
                                <a href={`${testMode ? '/test/' : '/'}orders/${order.redeemed_in_order}`} style={{ color: 'var(--link-color)' }}>
                                    {order.redeemed_in_order}
                                </a>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

           